/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function defaultSlider() {
	if (window.matchMedia("(min-width: 600px)").matches) {
		var centeredSlides = "false";
	} else {
		var centeredSlides = "ture";
	}

	const option = {
		loop: true,
		slidesPerView: "auto",
		initialSlide: 0,
		centeredSlides: centeredSlides,
		preventClicks: true,
		speed: 2000,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
		},
		navigation: {
			prevEl: ".button.--prev",
			nextEl: ".button.--next",
		},
	};

	const slider = new Swiper(".post-slider", option);
}

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/*index: フェードスライダー */

import { fadeSlider } from "./slider/fade/slider-fade-normal";

export { defaultSlider, fadeSlider };
